var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08278 14.2068C7.77926 14.491 7.37347 14.6499 6.95116 14.6499C6.52885 14.6499 6.12313 14.491 5.81954 14.2068C3.0395 11.5881 -0.686077 8.66273 1.13078 4.41566C2.11313 2.11931 4.47123 0.649902 6.95116 0.649902C9.43112 0.649902 11.7892 2.11931 12.7716 4.41566C14.5861 8.65741 10.8697 11.5971 8.08278 14.2068Z",
    stroke: "#292929",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 6.95C9.4 8.3031 8.3031 9.4 6.95 9.4C5.5969 9.4 4.5 8.3031 4.5 6.95C4.5 5.5969 5.5969 4.5 6.95 4.5C8.3031 4.5 9.4 5.5969 9.4 6.95Z",
    stroke: "#292929",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationImg);
export default __webpack_public_path__ + "static/media/locationImg.19f4f796c7eb0327e41eea023ec4d6be.svg";
export { ForwardRef as ReactComponent };